import { AuthorisedRoute } from 'core/router/AuthorisedRoute';
import { useRouteMatch } from 'react-router-dom';
import { CampaignList } from './pages/CampaignList/CampaignList';
import { CampaignEditor } from './pages/CampaignEditor/CampaignEditor';

/**
 *
 *
 * This is the starting point for the on-site campaign section of MSC. The plan is for this to eventually become the
 * standard UI for all campaigns but for now, everything is split out into offsite, onsite and MPS.
 *
 * The CampaignEditor is used to create new campaigns as well as edit existing campaigns. The UI distinguishes between
 * them by using "new" in the URL param for the campaignId.
 *
 * The CampaignEditor is a tabbed-based UI but each tab can be loaded independently, which is why each tab has its own
 * route.
 */
export function OnsiteCampaignSection() {
  const { path } = useRouteMatch();

  return (
    <>
      <AuthorisedRoute path={`${path}/:campaignId`} component={CampaignEditor} />
      <AuthorisedRoute exact={true} path={`${path}`} component={CampaignList} />
    </>
  );
}
